import logger from '@utils/logger';
import { useUpdateFloorplanMutation } from 'src/graphql/generated/graphql';

const useUpdateFloorplan = () => {
  const {
    mutate,
    mutateAsync,
    isError,
    isLoading: isPending,
    isSuccess,
    data,
  } = useUpdateFloorplanMutation({
    onError: (error) => {
      void logger.error('Call to updateFloorplan resulted in error', error as Error);
    },
    onSuccess: (response) => {
      const { error } = response.updateFloorplan;
      if (error) {
        // Throw so mutateAsync rejects; otherwise the GraphQL "fat error"
        // (HTTP 200 + success: false + error) leaks past callers' try/catch
        // and they'd render a success toast for a write that didn't land.
        void logger.error('Call to updateFloorplan resulted in error', error);
        throw new Error(error.errorMessage || 'updateFloorplan failed');
      }
      void logger.info('Floorplan pick path saved successfully');
    },
  });

  const { error } = data?.updateFloorplan ?? {};
  return {
    mutate,
    mutateAsync,
    isError,
    isLoading: isPending,
    isSuccess,
    error,
  };
};

export default useUpdateFloorplan;
